import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { PasswordService } from '../password.service';

/** 1.1 — Primeira senha de acesso da empresa (admin). */
export const useSetCompanyPassword = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (body: Passwords.SetCompanyPassword) =>
			PasswordService.adminSetCompanyPassword(body),
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: ['companies'] });
			queryClient.invalidateQueries({
				queryKey: ['company', variables.companyId],
			});
			toast.success('Senha de acesso definida com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(error, 'Erro ao definir senha de acesso'),
			);
		},
	});
};

/** 1.2 — Redefinir senha de acesso de empresa já existente (admin). Mesma API do 1.1. */
export const useUpdateCompanyPassword = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (body: Passwords.SetCompanyPassword) =>
			PasswordService.adminSetCompanyPassword(body),
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: ['companies'] });
			queryClient.invalidateQueries({
				queryKey: ['company', variables.companyId],
			});
			toast.success('Senha de acesso atualizada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(
				getErrorMessage(error, 'Erro ao atualizar senha de acesso'),
			);
		},
	});
};
